import React, { useState } from "react";

import "./inputField.css";


const InputField = ({ iconClass, iconSize, placeholder, fieldType, isInvalid, onChange, errorMessage, value, inputKey, maxWidth, onFocus, onBlur, disabled=false, descriptionMessage=null }) => { 
    
    const [isPassword, setIsPassword] = useState(true);

    const handlePasswordVisible = () => { 
        setIsPassword(!isPassword);
    }

    return (
        <div style={maxWidth && {
            maxWidth: maxWidth,
            textAlign: "left"
        }}>
            <div className={
                isInvalid ?
                    'input-field-control input-field-invalid'
                    :
                    "input-field-control"
            }>
                <i className={"bi " + iconClass + " input-icon"} style={iconSize && {fontSize: iconSize}}></i>
                <input
                    className='input-field input-field-text'
                    type={
                        isPassword ?
                            fieldType
                            :
                            "text"
                    }
                    id={inputKey}
                    name={inputKey}
                    placeholder={placeholder}
                    onChange={(e) => onChange(e.target.value)}
                    value={value === null ? "" : value}
                    onFocus={(e) => onFocus && onFocus(e)}
                    onBlur={(e) => onBlur && onBlur(e)}
                    disabled={disabled}
                />
                {
                    fieldType === "password" &&
                    <i className={
                            isPassword ?
                                "bi bi-eye-fill input-icon"
                                :
                                "bi bi-eye-slash-fill input-icon"
                        } onClick={handlePasswordVisible}></i>
                }
            </div>
            {errorMessage && <><span className="input-field-invalid-text">{errorMessage}</span><br /></>}
            <span className="input-field-description-text">{descriptionMessage}</span>
        </div>
    );
} 


export default InputField;
